"use client";

import Link from "next/link";
import { useState } from "react";

export type NavLinkItem = {
  href: string;
  label: string;
  active?: boolean;
};

type PortalNavBarProps = {
  links: NavLinkItem[];
  portalTitle?: string;
};

export default function PortalNavBar({
  links,
  portalTitle = "Portal Navigation",
}: PortalNavBarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="mb-10 rounded-2xl border border-slate-800 bg-slate-900 p-2 md:p-3">
      {/* Mobile Bar Header */}
      <div className="flex items-center justify-between px-3 py-1 md:hidden">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          {portalTitle}
        </span>
        <button
          type="button"
          onClick={() => setMobileMenuOpen((open) => !open)}
          className="rounded-lg border border-slate-700 bg-slate-800 px-3 py-1.5 text-xs font-medium text-slate-200 hover:border-slate-500"
        >
          {mobileMenuOpen ? "Close Menu ✕" : "Menu ☰"}
        </button>
      </div>

      {/* Navigation Links - Desktop Row & Mobile Dropdown */}
      <div
        className={`${
          mobileMenuOpen ? "flex" : "hidden"
        } flex-col gap-2 pt-2 md:flex md:flex-row md:flex-wrap md:pt-0`}
      >
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            onClick={() => setMobileMenuOpen(false)}
            className={`rounded-xl px-4 py-2.5 text-sm font-medium transition ${
              link.active
                ? "bg-blue-600 text-white shadow-md"
                : "text-slate-300 hover:bg-slate-800 hover:text-white"
            }`}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
